module.exports = __webpack_public_path__ + "img/IMG_2614_T_L_Foamcore_MockedUp.32501a55.jpg";